import { Type } from '@sinclair/typebox';
/**
 * Taxjar's address validation response schema.
 */
export const taxjarFullAdressSchema = Type.Object({
    street: Type.String(),
    city: Type.String(),
    state: Type.String(),
    country: Type.String(),
    zip: Type.String(),
});
const taxjarZipOnlyAdressSchema = Type.Omit(taxjarFullAdressSchema, ['street']);
export const taxjarAddressesResponseSchema = Type.Union([Type.Literal(false), Type.Union([taxjarFullAdressSchema, taxjarZipOnlyAdressSchema])]);
/**
 * Note that the cart address doesn't have a country code. This is because the cart country determines things like shipping methods, taxes and currency.
 * So we can't allow the shipping address to be in a different country than the cart itself. But the country on the billing address can be different, because
 * the billing address isn't really used for anything important.
 */
export const cartAddressSchema = Type.Object({
    // attName: Type.Optional(Type.String()),
    firstName: Type.String(),
    lastName: Type.String(),
    company: Type.Optional(Type.String()),
    address1: Type.String(),
    address2: Type.Optional(Type.String()),
    city: Type.String(),
    stateOrProvince: Type.Optional(Type.String()),
    postalCode: Type.String(),
    isValid: Type.Boolean(),
    matchesTaxJar: Type.Optional(Type.Boolean()),
    officialAddress: Type.Optional(taxjarAddressesResponseSchema),
});
export const cartBillingAddressSchema = Type.Intersect([
    cartAddressSchema,
    Type.Object({
        /**
         * Note that only the billing address has a country code. The shipping address is always assumed to be the same country as the cart itself.
         * This is because the cart country determines things like shipping methods, taxes and currency. So we can't allow the shipping address to
         * be in a different country than the cart itself. But the country on the billing address can be different, because the billing address isn't
         * really used for anything important.
         */
        countryCode: Type.Optional(Type.String()),
    }),
]);
const vatIsValidSchema = Type.Union([Type.Literal('validated'), Type.Literal('invalid'), Type.Literal('not validated')]);
export const cartCustomerCompanySchema = Type.Object({
    /**
     * This is a boolean in itself rather than setting the whole `customer.company` object to undefined. The reason
     * for this is that the UI has a checkbox for this, and if the checkbox is unchecked, we don't want to
     * clear the company name and VAT number.
     */
    isCompany: Type.Optional(Type.Boolean()),
    name: Type.Optional(Type.String()),
    vatNumber: Type.Optional(Type.Object({
        /**
         * This is the value inputted by the customer in the checkout
         */
        value: Type.String(),
        /**
         * If the value inputted by the customer in the checkout is valid.
         */
        isValid: vatIsValidSchema,
    })),
});
export const cartCustomerSchema = Type.Object({
    email: Type.Optional(Type.String()),
    phoneNumber: Type.Optional(Type.String()),
    company: Type.Optional(cartCustomerCompanySchema),
    /**
     * This is the customers main address, used for billing and shipping if no explicit billing address is set.
     */
    address: Type.Optional(cartAddressSchema),
    /**
     * This is the customers billing address, used for billing if set. If not set, the main address is the billing address.
     */
    billingAddress: Type.Optional(cartBillingAddressSchema),
    /**
     * This needs to be set for us to consider using the billingAddress property. Reason being that we model this against the state
     * of a checkbox on the checkout page, and if you accidentally uncheck the box, we don't want to clear the billing address.
     */
    useBillingAddress: Type.Optional(Type.Boolean()),
    reference: Type.Optional(Type.String()),
});
//# sourceMappingURL=customer.js.map